export default __webpack_public_path__ + "static/media/sounds/vocab_bd_practice_ready_instruction_alyx.mp3";